// A mock function to mimic making an async request for data
export function fetchAllFavCreditCard() {
  return new Promise(async (resolve) => {
    const response = await fetch(
      "http://44.195.241.28:8089/citizenbank/favcredit"
    );
    const data = response.json();
    resolve({ data });
  });
}
